import React from 'react';
import ForwardCover from '../../components/forward_cover/ForwardCover';

const ForwardCoverPage = () => {
    return (
        <div
            className="d-flex flex-column"
            style={{ height: '100vh', padding: '0', boxSizing: 'border-box', overflow: 'hidden' }}
        >
            <ForwardCover />
        </div>
    );
};

export default ForwardCoverPage;
